module.exports = __webpack_public_path__ + "img/sequence.f1b434d0.svg";